import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { environment } from 'src/environments/environment';
import { getMemberDeduct } from './deduct.interface';

@Component({
  selector: 'app-deduct',
  templateUrl: './deduct.component.html',
  styleUrls: ['./deduct.component.scss']
})
export class DeductComponent {
  contentRank = environment.contentRank
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.GetExchangerate();
  }


  memberItems!: getMemberDeduct
  tel: string = ""
  searchMember() {
    let model = {
      Tel: parseInt(this.tel)
    }
    this.http.post(`member/search`, model).subscribe({
      next: (res: any) => {
        this.memberItems = res.data
      }, error: () => {

      }, complete: () => {

      }
    })
  }
  ExchangerateItem: any = []
  GetExchangerate() {
    this.http.get(`point/exchangerate`).subscribe({
      next: (res: any) => {
        this.ExchangerateItem = res.data
      }, error: () => {

      }, complete: () => {

      }
    })
  }

  calculatePoints(amountSpent: number): number {
    const pointsPerBaht = this.ExchangerateItem.RatePoint / this.ExchangerateItem.RateAmount;
    return Math.floor(amountSpent * pointsPerBaht);
  }

  point: number = 0
  amount: number = 0
  Amount(e: any) {
    this.amount = parseInt(e.value)
    this.point = this.calculatePoints(e.value)

  }

  remark: string = ""
  DeductPoint() {
    let model = {
      Amount: this.amount,
      Member_id: this.memberItems.Member_id,
      Remark: this.remark
    }
    this.http.post(`point/deduct`, model).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
        this.memberItems = {} as getMemberDeduct;
        this.tel = ""
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

      }
    })
  }


}

